<form
  action=""
  class="login-form mrse-20 mrtb-10"
  [formGroup]="logInForm"
  (ngSubmit)="logIn()"
>
  <div class="mrtb-10 position-relative">
    <label class="d-block size-6 weight-600 mrb-4" for="login">{{
      "account.mail" | translate
    }}</label>
    <!-- <div class="error size-3 text-danger position-absolute">البريد الإلكتروني الذي قمت بإدخاله غير صحيح</div> -->
    <input
      class="w-100 error-focus border-0 border-radius-10 p-4"
      type="text"
      name="login"
      id="login"
      nbInput
      fullWidth
      formControlName="login"
      [class.is-invalid]="login?.invalid && (login?.dirty || login?.touched)"
    />
    <div class="invalid-feedback">
      <p *ngIf="login?.errors?.invalid">
        {{ "account.mail" | translate }} {{ "isInvalid" | translate }}
      </p>
      <p *ngIf="login?.errors?.required">
        {{ "account.mail" | translate }} {{ "isRequired" | translate }}
      </p>
    </div>
  </div>
  <div class="mrtb-10">
    <label class="d-block size-6 weight-600 mrb-4" for="password">{{
      "account.LoginPassword" | translate
    }}</label>
    <div class="position-relative height-40">
      <input
        appPassword
        class="w-100 border-0 border-radius-10 p-4"
        type="password"
        name="password"
        id="password"
        nbInput
        fullWidth
        formControlName="password"
        [class.is-invalid]="
          password?.invalid && (password?.dirty || password?.touched)
        "
      />
      <div class="invalid-feedback">
        <p *ngIf="password?.errors?.invalid">
          {{ "account.newPassword" | translate }} {{ "isInvalid" | translate }}
        </p>
        <p *ngIf="password?.errors?.required">
          {{ "account.newPassword" | translate }} {{ "isRequired" | translate }}
        </p>
      </div>
    </div>
    <div class="flex justify-content-center align-items-center">
      <div
        class="cursor-pointer text-end mrt-5 weight-600"
        (click)="navigateForget()"
      >
        {{ "account.forgotYourPassword" | translate }}
      </div>
    </div>
  </div>
  <div class="mrtb-10">
    <button
      class="btn rounded-2 w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600"
      type="submit"
      [disabled]="logInForm.invalid || isSubmitting"
    >
      <span *ngIf="!isSubmitting">{{ "account.logIn" | translate }}</span>
      <img
        *ngIf="isSubmitting"
        src="../../../../assets/images/spinner.gif"
        alt=""
        class="max-30"
      />
    </button>
    <div
      class="cursor-pointer text-center mrt-5 weight-600"
      (click)="navigateSignup()"
    >
      {{ "account.newUser" | translate }}
    </div>
  </div>
</form>
